// Monthly column chart. One series, so the panel title names it and no legend
// is needed; every column is labelled with its own value.
const TrendBars = ({ points, loading, empty = "Not enough history yet." }) => {
  if (loading) {
    return (
      <div className="flex h-40 items-end gap-3">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            style={{ height: `${30 + ((i * 17) % 55)}%` }}
            className="flex-1 animate-pulse rounded-t-md bg-gray-100"
          />
        ))}
      </div>
    );
  }

  if (!points.length) return <p className="py-6 text-sm text-gray-400">{empty}</p>;

  const max = Math.max(...points.map((p) => p.count), 1);

  return (
    <div>
      <div className="flex h-40 items-end gap-2 border-b border-gray-100 sm:gap-3">
        {points.map((point) => (
          <div key={point.key} className="flex h-full flex-1 flex-col justify-end gap-1.5">
            <span className="text-center text-[11px] font-semibold tabular-nums text-gray-500">
              {point.count}
            </span>
            <span
              title={`${point.label}: ${point.count}`}
              style={{ height: `${Math.max((point.count / max) * 100, 2)}%` }}
              className="w-full rounded-t-md bg-brand-500 transition-colors hover:bg-brand-600"
            />
          </div>
        ))}
      </div>

      <div className="mt-2 flex gap-2 sm:gap-3">
        {points.map((point) => (
          <span key={point.key} className="flex-1 text-center text-[11px] text-gray-400">
            {point.label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TrendBars;
